import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { getVehicle, getVehicles } from '../../../graph-ql/queries';
import { PaginationInput } from '../../models/common/paginationInput';
import { Vehicle } from '../../models/vehicle/vehicle.model';
import IGetVehiclesFilter from '../../models/vehicle/vehicleFilter.model';
import VehicleList from '../../models/vehicle/vehicleList.model';

@Injectable()
export class VehicleService {

  constructor(public apollo: Apollo) {
  }

  getVehicles$( pagination: PaginationInput, filter?: IGetVehiclesFilter): Observable<VehicleList> {
    return this.apollo.query<VehicleList>({
      query: getVehicles,
      variables: {
        input: {
          filter,
          pagination
        }
      }
    }).pipe(map(result => result.data['getVehicles']));
  }

  getVehicle$(vehicleId: string): Observable<Vehicle> {
    return this.apollo.query<Vehicle>({
      query: getVehicle,
      variables: {
        vehicleInput: {
          id: vehicleId
        }
      }
    }).pipe(map(result => result.data['getVehicle']));
  }
}
